import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { pdiIcons } from 'pages/PDI/utils';

import PDFModal from 'components/PDFModal';

import * as S from './styles';

import CertificateBox from './CertificateBox';

const SendedCertificates = ({ certificates }) => {
  const [previewVisibility, setPreviewVisibility] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState('');

  const handlePreviewCertificate = (certificate) => {
    setPreviewVisibility(true);
    setSelectedCertificate(certificate);
  };

  return (
    <>
      <S.Container>
        <S.Head>
          <S.Icon>{pdiIcons('certifiedKnowledge', '#118ACA')}</S.Icon>
          Certificados enviados
        </S.Head>
        <S.Certificates>
          <S.CertificatesQuantity>
            <S.Counter>{certificates?.length || 0}</S.Counter>
            <S.Description>{certificates?.length > 1 ? 'Documentos' : 'Documento'}</S.Description>
          </S.CertificatesQuantity>
          <S.CertificatesSlider>
            {certificates?.map(data => (
              <CertificateBox handlePreview={handlePreviewCertificate} data={data} />
            ))}
          </S.CertificatesSlider>
        </S.Certificates>
      </S.Container>

      {previewVisibility && <PDFModal base64={selectedCertificate} isVisible={previewVisibility} setIsVisible={setPreviewVisibility} />}
    </>
  );
};

SendedCertificates.propTypes = {
  certificates: PropTypes.arrayOf(
    PropTypes.shape({
      area: PropTypes.string,
      bloco: PropTypes.string,
      questao: PropTypes.string,
    }),
  ).isRequired,
};
export default SendedCertificates;
